import React from "react";
import { Link } from "react-router-dom";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { JdsButton } from "../../components/jds/JdsButton";
import "../../components/jds/jds.css";
import "./ErrorPage1.css";

export function ErrorPage1() {
  return (
    <div className="jds-scope error-page">
      <div className="jds-card error-page__card">
        <img
          className="error-page__logo"
          src={toAbsoluteUrl("/media/logos/jusfy-logo.svg")}
          alt="Jusfy"
        />
        <h1 className="jds-title-lg">Página não encontrada</h1>
        <p className="error-page__text">
          O endereço que você acessou não existe ou foi movido.
        </p>
        <Link to="/dashboard">
          <JdsButton>Voltar para o início</JdsButton>
        </Link>
      </div>
    </div>
  );
}
